import { Routes } from '@angular/router';

/**
 * The Showcase's route, in a file of its own so that it can be swapped out of a deployed build.
 *
 * `angular.json` replaces this file with `showcase-route.deployed.ts` — which registers nothing
 * and imports nothing — in the production and staging configurations. That is what actually
 * keeps the Showcase out of a shipped bundle: a `environment.production ? [] : [...]` ternary
 * in the route table does not, because a dynamic `import()` becomes a chunk when the bundle
 * graph is built, before any constant is folded. It would ship as a lazy chunk nobody loads.
 */
export const showcaseRoute: Routes = [
  {
    path: 'showcase',
    loadChildren: () => import('./showcase.routes').then((m) => m.showcaseRoutes),
  },
];
